import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation createUcceMrd($model: UcceMrdInput!) {
  createUcceMrd(ucceMrd: $model){
    id
    activitiesLimit
    mrdId
    mrdName
    scriptSelector
    channelTypes
  }
}`;

function createUcceMrd(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createUcce);
}

export default createUcceMrd;
